import React from "react";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { BenefitsSummaryData } from "../benefitsSummary.types";

interface InsuranceDetailsCardProps {
  insurance: BenefitsSummaryData["insurance"];
  checkedOn: string;
}

const InsuranceDetailsCard = ({
  insurance,
  checkedOn,
}: InsuranceDetailsCardProps) => {
  const fields = [
    { label: "Insurance provider", value: insurance.provider },
    { label: "Plan name", value: insurance.planName },
    { label: "Member ID", value: insurance.memberId },
    { label: "Policyholder", value: insurance.policyholder },
  ];

  return (
    <Paper sx={{ p: 3 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={1}
      >
        <Typography variant="h6">Insurance details</Typography>
        <Chip
          icon={<VerifiedOutlinedIcon />}
          label={`Benefits checked ${checkedOn}`}
          color="success"
          size="small"
        />
      </Stack>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        {fields.map((field) => (
          <Grid key={field.label} size={{ xs: 6, md: 3 }}>
            <Typography variant="body2" color="text.secondary">
              {field.label}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, overflowWrap: "anywhere" }}
            >
              {field.value}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default InsuranceDetailsCard;
